<template>
  <v-container grid-list-xs fill-height>
    <v-img class="background" src="/img/background-blur.jpg"></v-img>
    <v-layout align-center justify-center fill-height>
      <v-flex xs12 sm8 md6 xl4>
        <v-card class="elevation-12">
          <v-toolbar color="#BBA981" dark flat>
            <v-toolbar-title>Générateur</v-toolbar-title>
            <v-spacer />
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-select prepend-icon="mdi-checkerboard" :items="scenarios" item-value="id" v-model="scenarioId" label="Scenario" solo clearable>
                <template slot="selection" slot-scope="data"> {{ data.item.type }} - {{ data.item.sc_name }} </template>
                <template slot="item" slot-scope="data"> {{ data.item.type }} - {{ data.item.sc_name }} </template>
              </v-select>
              <v-dialog ref="dialog" v-model="modal" :return-value.sync="date" persistent width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="date" label="Date de fin de validité (exclu)" prepend-icon="mdi-calendar"
                    readonly v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="date" scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="modal = false">
                    Cancel
                  </v-btn>
                  <v-btn text color="primary" @click="$refs.dialog.save(date)">
                    OK
                  </v-btn>
                </v-date-picker>
              </v-dialog>
              <div class="code" v-if="scenarioId !== -1">
                {{code}}
              </div>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    data: () => ({
      scenarios: [],
      scenarioId: 28,
      date: ((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
      modal: false,
      key: "JSMOEKSBCP"
    }),
    computed: {
      code() {
        var scenarioIdConverted = (this.scenarioId + '').split('').map((x) => this.key[parseInt(x)]).join('')
        var endDateConverted = this.date.split('-').join('').substring(2).split('').map((x) => this.key[parseInt(x)]).join('')
        return scenarioIdConverted + endDateConverted
      }
    },
    created() {
      this.loadScenarios()
    },
    mounted() {
        if(SAPIO.User.instance.type !== "admin") {
          this.$router.push('/')
        }
    },
    methods: {
      loadScenarios() {
        SAPIO.Loader.instance
          .loadScenarios()
          .then((response) => {
            this.scenarios = response
            this.$notify({ group: 'app', type: 'info', title: 'Scénario disponibles chargés !', text: 'Veuillez sélectionner un scénario.' })
          })
          .catch((e) => {
            this.scenarios = []
            this.$notify({ group: 'app', type: 'error', title: 'Erreur lors du chargement des scénarios', text: e.message })
            console.error(e)
          })
      },
    },
  }
</script>

<style scoped>
  img {
    max-width: 100%;
    height: auto;
    width: auto\9;
  }
  #spinner_container {
    text-align: center;
  }
  .spinner {
    margin: auto;
    margin: 4rem;
  }

  .background {
    position: fixed;
    top: 0;
    left: 0;
    min-width: 100%;
    min-height: 100%;
  }

  .code {
    text-align: center;
    font-weight: 600;
    font-size: 30px;
    padding: 30px;
  }
</style>
